/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback } from 'react';
import { IMeetingManuItemsProps } from './types';
import { useSelect, useSelectWithParams } from '../../../../../utils/selector.utils';
import { meetingSimpleSelectors } from '../../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { authSelectors } from '../../../../../app/auth/auth.selectors';
import { isMemberPartOfMeeting } from '../../../../../utils/user.utils';
import { userSelectors } from '../../../../../app/resource/user/user.selectors';
import { FiFolderPlus } from 'react-icons/fi';
import { openDialog } from '../../../../../app/dialog/dialog.actions';
import { useDispatch } from 'react-redux';
import { meetingsFoldersPageSelectors } from '../../../../../app/page/page-storage/meeting-folder/meeting-folder.selectors';
import { meetingFolderSelectors } from '../../../../../app/resource/meeting-folder/meeting-folder.selectors';
import { IMeetingFolder } from '../../../../../app/resource/meeting-folder/meeting-folder.types';
import { MeetingFolder } from '../MeetingFolder';
import { DragDropContext, DropResult } from 'react-beautiful-dnd';
import { updateFolderForMeeting } from '../../../../../app/page/page-storage/meetings-simple/meetings-simple.actions';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { MeetingList } from './MeetingList';
import { IconContext } from 'react-icons';
import { useSidebarCollapsed } from '../../../../../utils/sidebarWidth.utils';
import { sortBy } from 'lodash';
import { useLocalStorage } from '../../../../../utils/custom-hooks/useLocalStorage.utils';

export const MeetingMenuItems: FunctionComponent<IMeetingManuItemsProps> = ({ type, meetingIds }) => {
  const dispatch = useDispatch();
  const loggedUserId = useSelect(authSelectors.selectLoggedUser) || '';
  const [selectedFolder, setSelectedFolder, removeSelectedFolder] = useLocalStorage<string | null>(
    'selectedFolder',
    null,
  );
  const user = useSelectWithParams(userSelectors.selectResourceById, loggedUserId);
  const isLoggedUserAdmin = useSelect(authSelectors.selectUserIsAdmin);

  const meetingFoldersIds = useSelect(meetingsFoldersPageSelectors.selectMeetingFoldersIds);
  let meetingFolders = useSelectWithParams(
    meetingFolderSelectors.selectResourcesById,
    meetingFoldersIds,
  ) as IMeetingFolder[];

  meetingFolders = sortBy(meetingFolders, 'name');

  const meetingWithinFolders = meetingFolders.reduce(
    (accumulator: string[], currentValue) => accumulator.concat(currentValue.meetingIds),
    [],
  );

  let meetings = useSelectWithParams(meetingSimpleSelectors.selectResourcesById, meetingIds);

  if (user && isLoggedUserAdmin) {
    meetings = meetings.filter((meeting) => {
      let isMeetingMember = false;
      if (meeting) {
        isMeetingMember = isMemberPartOfMeeting(user, meeting);
      }
      return isMeetingMember;
    });
  }

  let meetingsWithoutFolders = meetings.filter((meeting) => {
    if (meeting) {
      return !meetingWithinFolders.includes(meeting.id);
    }
  });
  meetingsWithoutFolders = sortBy(meetingsWithoutFolders, 'title');

  const openAddFolderFormDialog = useCallback(() => {
    dispatch(openDialog('meetingFolderFormDialog'));
  }, [dispatch]);

  const handleDrop = useCallback(
    (result: DropResult) => {
      let folderId: string | null = null;
      if (result.destination?.droppableId == '0') {
        folderId = null;
      } else {
        folderId = result.destination?.droppableId ?? null;
      }

      dispatch(updateFolderForMeeting(result.draggableId, { folderId }));
    },
    [dispatch],
  );

  const isSidebarCollapsed = useSidebarCollapsed();

  return (
    <>
      <DragDropContext onDragEnd={handleDrop}>
        <div className="add-folder">
          <div className="menu-title">{type === 'account' ? 'My Accounts' : 'My Meetings'}</div>
          <div className="ml-auto flex">
            <div className="btn-badge">
              <button className="folder-icon" onClick={openAddFolderFormDialog}>
                <FiFolderPlus />
              </button>
            </div>
          </div>
        </div>
        {selectedFolder ? (
          <div onClick={() => setSelectedFolder(null)} className="return-link">
            <IconContext.Provider value={{ color: 'white' }}>
              <IoMdArrowRoundBack size={20} />
            </IconContext.Provider>
          </div>
        ) : null}

        <ul className="folder-menu">
          {meetingFolders.map((folder: IMeetingFolder) => (
            <li key={folder.id} className="folder">
              <MeetingFolder
                folder={folder}
                selected={selectedFolder}
                setSelectedFolder={setSelectedFolder}
                isSidebarCollapsed={isSidebarCollapsed}
              />
            </li>
          ))}
          {!selectedFolder && (
            <MeetingList meetings={meetingsWithoutFolders} isSidebarCollapsed={isSidebarCollapsed} droppableId="0" />
          )}
        </ul>
      </DragDropContext>
    </>
  );
};
